import { useEffect, useRef } from 'react';

import { loadGoogleMapsScriptConfig } from 'config/loadGoogleMapsScriptConfig';

const DEFAULT_LOCATION = {
  lat: 55.4038, // Odense Latitude
  lng: 10.4024, // Odense Longitude
};

type Props = Partial<{
  lat: number;
  lng: number;
  zoom: number;
}>;

const GoogleMapViewer = (props: Props) => {
  const { lat, lng, zoom = 10 } = props;
  const mapRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    async function initMap() {
      try {
        await loadGoogleMapsScriptConfig();

        const mapCenter = {
          lat: lat || DEFAULT_LOCATION.lat,
          lng: lng || DEFAULT_LOCATION.lng,
        };

        if (mapRef.current) {
          const map = new google.maps.Map(mapRef.current, {
            center: mapCenter,
            zoom,
          });

          new google.maps.Marker({
            position: mapCenter,
            map,
          });
        }
      } catch (err) {
        console.error('Google Maps failed to load:', err);
      }
    }

    initMap();
  }, [lat, lng, zoom]);

  return <div ref={mapRef} style={{ height: '100%', width: '100%' }} />;
};

export default GoogleMapViewer;
